var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-container"},[_c('h3',{staticClass:"title is-spaced"},[_vm._v("Reptes realitzats")]),_vm._v(" "),_c('UserIntents',{attrs:{"intents":_vm.userIntents}}),_vm._v(" "),(_vm.userIntents && _vm.userIntents.length == 0)?_c('p',{staticClass:"desc has-margin-top-3"},[_vm._v("\n    Encara no has superat cap repte\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73492148","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyIntents.vue
// module id = null
// module chunks = 